import { render } from "./PartialOrders.vue?vue&type=template&id=ebfff9d4"
import script from "./PartialOrders.vue?vue&type=script&lang=js"
export * from "./PartialOrders.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/orders/PartialOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ebfff9d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ebfff9d4', __exports__)) {
    console.log('reload')
    api.reload('ebfff9d4', __exports__)
  }
  
  module.hot.accept("./PartialOrders.vue?vue&type=template&id=ebfff9d4", () => {
    console.log('re-render')
    api.rerender('ebfff9d4', render)
  })

}


export default __exports__